import {Injectable} from '@angular/core';
import {Router} from '@angular/router';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import {catchError, map, switchMap} from 'rxjs/operators';

import {debug} from '../../../rxjs-operators';
import {LoadMyClientsFailAction, LoadMyClientsSuccessAction, myClientsActionTypes} from '../actions/my-clients';
import {error} from '../actions/toasts';
import {ArrayResponse} from '../models/array-response';
import {Client} from '../models/client';
import {SendBackResult} from '../models/send-back-result';
import {ClientsService} from '../services/clients.service';

import {BaseEffect} from './base.effect';
import {L10nTranslationService} from 'angular-l10n';

@Injectable()
export class MyClientsEffect extends BaseEffect {

  load$ = createEffect(() => { return this.actions$.pipe(
              ofType(myClientsActionTypes.LOAD),
              debug('Load my clients action received.'),
              switchMap(() => this.myClientsService.getMine().pipe(
                              map((result: SendBackResult<ArrayResponse<Client>>) => new LoadMyClientsSuccessAction(result.data.array)),
                              catchError(res => this.catchResponseError(res)),
                              )))});


  loadFail$ = createEffect(() => { return this.actions$.pipe(
    ofType(myClientsActionTypes.LOAD_FAIL),
    debug('A server error occurred while retrieving clients list.'),
    map((action: LoadMyClientsFailAction) =>
      error(this.translation.translate('MY_CLIENTS_LOAD_ERROR') + '  ' + action.payload,
      this.translation.translate('TOAST_ERROR_TITLE')))) });

  constructor(private actions$: Actions,
              private translation: L10nTranslationService,
              private myClientsService: ClientsService, router: Router) { super(router); }

  protected handleUnhandledError = (response) => new LoadMyClientsFailAction(response['error'].message)

  protected handleGoneError = (response) => {
    return new LoadMyClientsFailAction(response['error'].message);
  }
}
